import { Radio } from 'antd';
import { RadioButtonProps } from 'antd/es/radio/radioButton';

const { Button } = Radio;
export type AppRadioButtonProps = RadioButtonProps;

export const AppRadioButton = ({ ...props }: AppRadioButtonProps) => <Button {...props} />;
